import { render } from "./ExhibitorKit.vue?vue&type=template&id=1b81a3c7&scoped=true"
import script from "./ExhibitorKit.vue?vue&type=script&lang=js"
export * from "./ExhibitorKit.vue?vue&type=script&lang=js"

import "./ExhibitorKit.vue?vue&type=style&index=0&id=1b81a3c7&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b81a3c7"]])

export default __exports__